// src/portals/fan/components/BottomNavBar.js
import React from "react";
import { NavLink } from "react-router-dom";
import {
  Home,
  Library,
  MessageSquare,
  User,
  LayoutDashboard,
} from "lucide-react";
import { useAuth } from "../../../context/AuthContext";
import { useLayout } from "../../../context/LayoutContext";

const NavItem = ({ to, Icon, label, isEnd = false }) => (
  <NavLink
    to={to}
    end={isEnd}
    aria-label={label}
    className={({ isActive }) =>
      `flex flex-col items-center justify-center flex-1 pt-2 pb-1 gap-1 transition-colors duration-200 ${
        isActive ? "text-primary" : "text-slate-500 hover:text-primary"
      }`
    }
  >
    {({ isActive }) => (
      <>
        <Icon size={24} strokeWidth={isActive ? 2.5 : 2} aria-hidden="true" />
        <span
          className={`text-xs ${isActive ? "font-semibold" : "font-normal"}`}
        >
          {label}
        </span>
      </>
    )}
  </NavLink>
);

const BottomNavBar = () => {
  const { currentUser } = useAuth();
  const { setLayoutMode } = useLayout();

  const handleDashboardClick = () => {
    setLayoutMode("mobile");
  };

  const isCreator = currentUser?.role === "creator";

  // ✨ THE FIX: The destination of the dashboard button is now conditional
  const dashboardPath = isCreator ? "/dashboard" : "/fan/become-creator";

  return (
    <div className="w-full h-16 bg-white border-t border-slate-200 flex items-center justify-between mt-auto shadow-[0_-2px_5px_rgba(0,0,0,0.03)]">
      {/* ✨ The layout is now the same for all users, no more conditional rendering here */}
      <>
        <NavItem to="/fan" Icon={Home} label="Home" isEnd={true} />
        <NavItem to="/fan/library" Icon={Library} label="Collection" />

        <div className="flex-1 flex justify-center">
          <NavLink
            to={dashboardPath} // ✨ Use the conditional path
            onClick={handleDashboardClick}
            className="flex flex-col items-center gap-1 -mt-6 relative z-50"
          >
            <div className="w-16 h-16 rounded-full bg-primary flex items-center justify-center text-white shadow-lg border-4 border-white">
              <LayoutDashboard size={32} strokeWidth={2.5} />
            </div>
            <span className="text-xs font-semibold text-primary">Creator</span>
          </NavLink>
        </div>

        <NavItem to="/fan/messages" Icon={MessageSquare} label="Messages" />
        <NavItem to="/fan/profile" Icon={User} label="Profile" />
      </>
    </div>
  );
};

export default BottomNavBar;
